import { ContentButtonNavigation } from "hec/components/ui/carousel";
import { navButtonTypes } from "hec/components/ui/carousel.utils";
import type * as React from "react";

import type { RegisteredComponent } from "@builder.io/sdk-react";

interface CustomCarouselContentNavProps {
  buttonColor?: string;
  inactiveButtonColor?: string;
  buttonType?: string;
  attributes?: Record<string, unknown>;
}

export const CustomCarouselContentNav = (
  props: CustomCarouselContentNavProps,
) => {
  const {
    buttonColor,
    inactiveButtonColor,
    buttonType = navButtonTypes.CircleButton,
    attributes,
  } = props;

  return (
    <ContentButtonNavigation
      buttonType={buttonType as keyof typeof navButtonTypes}
      buttonColor={buttonColor}
      {...(buttonType === navButtonTypes.FlatButton
        ? { inactiveButtonColor }
        : {})}
      {...(attributes as React.HTMLAttributes<HTMLDivElement>)}
      data-testid="carouselContentNav-ContentButtonNavigation"
    />
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const CarouselContentNavDefinition: RegisteredComponent = {
  component: CustomCarouselContentNav,
  name: "CarouselContentNav",
  noWrap: true,
  inputs: [
    {
      name: "buttonType",
      type: "string",
      enum: Object.values(navButtonTypes),
      defaultValue: navButtonTypes.CircleButton,
    },
    {
      name: "buttonColor",
      type: "color",
    },
    {
      name: "inactiveButtonColor",
      type: "color",
      showIf: `options.get('buttonType') === '${navButtonTypes.FlatButton}'`,
    },
  ],
};
